import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const HookBannerWrapper = styled(Flex)`
    position: static;
    width: 100%;
    box-sizing: border-box;
    background-color: ${colorsPalettes.midnight[600]};
    padding: 31px 35px;
    border-radius: 12px;
    align-items: center;
    justify-content: space-between;
`;
